import * as _ from 'lodash';

import { utils } from '@blend/ui-common';

import * as privacyPolicyAPI from 'login-apis/privacyPolicyAPI';
import Checkbox from '../CheckboxInput/CheckboxInput';

const { globalWrappers } = utils;

export type AcceptedTermsTypes =
  | 'termsOfUse'
  | 'privacyPolicy'
  | 'eConsent'
  | 'consentToLenderContact'
  | 'softCreditConsent'
  | 'softCreditConsentWithTWN';

export const softCreditConsentTypes = ['softCreditConsent', 'softCreditConsentWithTWN'];

export interface TermsTypesDisplayInfo {
  linkPrefix?: string | null;
  linkDisplay: string;
  linkSuffix?: string | null;
  textScreenId: string;
  headerText: string;
}

export function getBaseSoftCreditConsentDisplayInfo() {
  return {
    linkPrefix: globalWrappers.getDeploymentConfig().useExtendedConsentLanguage
      ? 'authorize you to obtain my credit information according to the '
      : null,
    linkDisplay: 'Credit Consent',
    linkSuffix: null,
    headerText: 'Credit Consent',
  };
}

// TODO (UI-5074): Make this common
export function getTermsTypesDisplayInfo(): Record<AcceptedTermsTypes, TermsTypesDisplayInfo> {
  return {
    termsOfUse: {
      linkPrefix: null,
      linkDisplay: 'Terms Of Use',
      linkSuffix: globalWrappers.getDeploymentConfig().useExtendedConsentLanguage
        ? ' (including consent to electronically access your financial information ' +
          'for the purposes of this transaction)'
        : null,
      textScreenId: 'terms',
      headerText: 'Terms Of Use',
    },
    privacyPolicy: {
      linkPrefix: null,
      linkDisplay: 'Privacy Policy',
      linkSuffix: null,
      textScreenId: privacyPolicyAPI.getPrivacyPolicyTextScreenId(),
      headerText: 'Privacy Policy',
    },
    eConsent: {
      linkPrefix: null,
      linkDisplay: 'Consent to Use Electronic Signatures and Records',
      linkSuffix: null,
      textScreenId: 'required-blend-e-consent',
      headerText: 'ESIGN Act Consent',
    },
    consentToLenderContact: {
      linkPrefix: null,
      linkDisplay: 'Consent to Contact',
      linkSuffix: null,
      textScreenId: 'consent-to-lender-contact',
      headerText: 'Consent to Contact',
    },
    softCreditConsent: {
      ...getBaseSoftCreditConsentDisplayInfo(),
      textScreenId: 'soft-credit-consent',
    },
    softCreditConsentWithTWN: {
      ...getBaseSoftCreditConsentDisplayInfo(),
      textScreenId: 'soft-credit-consent-with-twn',
    },
  };
}

// TODO (UI-5074): Make this common
// injects strings like ' ', ', ', and ', and ' to format the linkButtons
export function separateList(list: any[]) {
  // because of the Oxford comma rule, only lists of 3 or more are comma separated
  const separator = list.length > 2 ? ', ' : ' ';
  const lastSeparator = `${separator}and `;
  return _.flatten(list.map((link, i) => (i === 0 ? link : [i === list.length - 1 ? lastSeparator : separator, link])));
}

export function getSeparatedDisplayPartsFromAcceptedTermsTypes(
  acceptedTermsTypes: Checkbox.Props['displayParts'],
  openModal: (textScreenId: string, headerText: string) => void,
): Checkbox.Props['displayParts'] {
  const separatedAcceptedTermsTypes = separateList(acceptedTermsTypes);
  return _.flatten(
    _.map(separatedAcceptedTermsTypes, acceptedTermsTypeOrSeparator => {
      const displayInfo = getTermsTypesDisplayInfo()[acceptedTermsTypeOrSeparator];
      if (!displayInfo) return acceptedTermsTypeOrSeparator;

      return _.compact([
        displayInfo.linkPrefix,
        {
          display: displayInfo.linkDisplay,
          onClick: () => openModal(displayInfo.textScreenId, displayInfo.linkDisplay),
        },
        displayInfo.linkSuffix,
      ]);
    }),
  );
}
